import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"
import { useEffect } from "react"

import { Button } from "@/components/Button/Button.tsx"
import { Centered } from "@/components/Centered/Centered.ts"
import { HmmError, SvgIllustration } from "@/illustrations/Illustrations.ts"
import { pageTitle } from "@/lib/displayUtils.ts"
import { getLogger } from "@/lib/logging.ts"
import { Page } from "@/routes/auth/Page.tsx"
import { PageBackgroundGradient } from "@/routes/auth/PageBackgroundGradient.ts"
import { Navigator } from "@/routes/Navigator.ts"

import type { NotFoundRouteProps } from "@tanstack/react-router"


const log = getLogger("NotFoundScene")

export const NotFoundScene = (props: NotFoundRouteProps) => {
  useEffect(() => {
    log.error("Not found:", props.data)
  }, [props.data])

  return (
    <Page backgroundGradient={PageBackgroundGradient.Orgs} orgPage={false} withMainMenu={false} withUserMenu={false}>
      <title>{pageTitle("Page is missing")}</title>
      <Centered gap="24px">
        <HmmError className={SvgIllustration} />
        <ErrorSubtext>Looks like the page is missing — hopefully it doesn't matter much.</ErrorSubtext>
        <ButtonWrapper>
          <Link {...Navigator.home()} viewTransition>
            <Button kind="secondary" size="large" tabIndex={-1}>
              Back to organizations
            </Button>
          </Link>
        </ButtonWrapper>
      </Centered>
    </Page>
  )
}

const ErrorSubtext = styled.p`
  margin: 0;

  font-size: 18px;
  color: var(--secondary-text-color);

  text-align: center;
`

const ButtonWrapper = styled.div`
  margin-top: 16px;
`
